// extracted by mini-css-extract-plugin
export default {"block":"ProductsGridContainer_block__LbTYy","title":"ProductsGridContainer_title__0dGb5","complectsSelect":"ProductsGridContainer_complectsSelect__L2hFm"};